import React from 'react';
import { Button } from '@/components/ui/button';
import { Eye, EyeOff } from 'lucide-react';
import { useFocusMode } from '@/contexts/FocusModeContext';
import { cn } from '@/lib/utils';

interface FocusModeToggleProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'default' | 'sm' | 'icon';
  className?: string;
  showLabel?: boolean;
}

export const FocusModeToggle: React.FC<FocusModeToggleProps> = ({
  variant = 'ghost',
  size = 'sm',
  className,
  showLabel = false,
}) => {
  const { focusMode, toggle } = useFocusMode();
  const Icon = focusMode ? EyeOff : Eye;
  return (
    <Button
      variant={variant}
      size={size}
      onClick={toggle}
      className={cn('gap-2', className)}
      title="Modo enfoque (F)"
      aria-label="Modo enfoque"
    >
      <Icon className="h-4 w-4" />
      {showLabel && <span className="text-xs">{focusMode ? 'Salir enfoque' : 'Enfoque'}</span>}
    </Button>
  );
};
